import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

export default {
  state: {
    messages: [],
    totalMessages: 0,
    totalUnreadMessages: 0,
  },
  actions,
  mutations: {
    [mutationTypes.SET_CURRENT_CHAT_MESSAGES](state, messages) {
      state.messages = messages
    },
    [mutationTypes.SET_CURRENT_CHAT_MESSAGES_TOTAL](state, totalMessages) {
      state.totalMessages = totalMessages
    },
    [mutationTypes.SET_CURRENT_CHAT_MESSAGES_TOTAL_UNREAD](state, totalUnreadMessages) {
      state.totalUnreadMessages = totalUnreadMessages
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/index.js